import r from "./_getNative.js";
var t = function() {
  try {
    var e = r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (o) {
  }
}();
const i = t;
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_defineProperty.js
// module id = 912
// module chunks = 67